import { combineReducers } from "redux";
import commonReducer from "@frameworks/web/redux/feature/Markets/Common/Reducers/commonReducer";
import IPOOrderBookReducer from "./ipoOrderBook";
export default combineReducers({
    reducersData: IPOOrderBookReducer,
    commonData: commonReducer,
});
